import { VoucherVendorDefinitionId } from "@/services/core-api-adapter";
import { DoctorNurseVoucherTypeSelection } from ".";

export default function DoctorNurseVoucherTypeSelectionExamples() {
  function onSelectNurseConsult() {
    console.log("Nurse consult selected");
  }

  function onSelectDoctorConsult() {
    console.log("Doctor consult selected");
  }

  function onBackButtonClick() {
    console.log("Back button clicked");
  }

  return (
    <DoctorNurseVoucherTypeSelection
      onNurseConsultClick={onSelectNurseConsult}
      onDoctorConsultClick={onSelectDoctorConsult}
      onBackButtonClick={onBackButtonClick}
      selectedVoucher={{
        voucherTypeId: "07c931b5-662e-4852-9d6a-d320a827751c",
        name: "Direct-to-doctor",
        description: "",
        order: 3,
        vendorName: "UnuHealth",
        voucherSubTypes: [
          {
            voucherSubTypeId: "4d48eb90-e30f-42d7-af25-a11df75ec1e6",
            name: "Nurse",
            description: "",
            voucherVendorDefinitionId: VoucherVendorDefinitionId.NURSE_CONSULT,
            order: 2,
            amount: 17900,
            chargeCode: "NURSE_CONSULT",
            currencyCode: "ZAR",
            isDiscountApplied: false,
            discountAmount: 0,
            originalAmount: 17900,
          },
          {
            voucherSubTypeId: "4d48eb90-e30f-42d7-af25-a11df75ec1e6123",
            name: "Doctor",
            description: "",
            chargeCode: "DOCTOR_CONSULT",
            isDiscountApplied: false,
            voucherVendorDefinitionId: VoucherVendorDefinitionId.DOCTOR_CONSULT,
            order: 2,
            amount: 23900,
            currencyCode: "ZAR",
            discountAmount: 0,
            originalAmount: 23900,
          },
        ],
      }}
    />
  );
}
